import { useQuery } from "@tanstack/react-query";
import { fetchCameras } from "../api/fetch-cameras";

export const CAMERAS_QUERY_KEY = "cameras";

export function useCameras(branchUid: string | undefined, versionId?: number) {
  return useQuery({
    queryKey: [CAMERAS_QUERY_KEY, branchUid, versionId],
    queryFn: () => fetchCameras(branchUid!, versionId),
    enabled: Boolean(branchUid),
  });
}
